import { parse, addDays, subDays, format, parseISO, isValid } from "date-fns";

export function dateModified(
  dataStr: string,
  days: number,
  addDaysFormat: boolean
) {
  if (!dataStr) return '';
  
  const normalized = dataStr.trim();
  
  const data = parse(normalized, "yyyy-MM-dd", new Date());
  if (isNaN(data.getTime())) return '';
  
  const novaData = addDaysFormat
  ? addDays(data, days)
  : subDays(data, days);
  
  return format(novaData, "dd/MM/yyyy");
}

export function formatarDataBR(data: string, addTime: boolean = false): string {
  if (!data) return "";

  const date = parseISO(data);

  if (!isValid(date)) return "";

  if (addTime) return format(date, "dd/MM/yyyy HH:mm:ss");

  return format(date, "dd/MM/yyyy");
}
